'use client'

import dynamic from 'next/dynamic'

// Only for the header's login button, which is on every page — this is the sole route formik takes
// into the shell. Pages that render <AuthModal> inline should keep importing it directly.
export const AuthModalLazy = dynamic(() => import('./AuthModal').then(({AuthModal}) => AuthModal), {
  ssr: false,
})
